import { Controller } from "@hotwired/stimulus"

// Renumbers the visible step position labels after a Ui::DraggableListComponent
// reorder. Persistence is handled by the draggable-list controller itself (via
// reorder_url); this only keeps the [data-position] display in sync.
export default class extends Controller {
  reindex() {
    this.element.querySelectorAll("[data-position]").forEach((el, i) => {
      el.textContent = i + 1
    })
  }
}
